if (!customElements.get('product-description-toggle')) {
  customElements.define(
    'product-description-toggle',
    class ProductDescriptionToggle extends HTMLElement {
      connectedCallback() {
        this.content = this.querySelector('[data-description-content]');
        this.button = this.querySelector('[data-description-toggle]');
        if (!this.content || !this.button) return;

        this.showMoreText = this.button.textContent.trim();
        this.showLessText = this.button.dataset.showLessText || this.showMoreText;

        this.button.addEventListener('click', () => this.toggle());
      }

      toggle() {
        const expanded = this.content.classList.toggle('is-expanded');
        this.button.textContent = expanded ? this.showLessText : this.showMoreText;
      }
    }
  );
}
